<template>
  <div v-if="!disableDigitalAccountOption">
    <v-row cols="12">
      <v-flex col="10" class="pa-0">
        <v-switch
          v-model="create_digital_account"
          :readonly="false"
          :label="field.label"
          :disabled="disabled"
        />
      </v-flex>

      <!-- <v-flex v-if="create_digital_account && editable" col="2" class="pa-0">
        <v-select
          v-model="pool_name"
          item-text="label"
          item-value="value"
          :items="poolItems"
          label="Unité métier d'origine"
          :rules="[v => v.length > 0 || 'Required']"
        />
      </v-flex> -->
      <div v-if="showResetPasswordButton">
        <v-btn
          color="primary"
          class="ma-5"
          small
          @click="handleResetCustomerPassword"
        >
          Réinitialiser le mot de passe
        </v-btn>
      </div>
      <Modal max-width="370" :show.sync="showSelectWorkspaceModal" :close="closeSelectWorkspaceModal">
        <template #title>
          <span class="title">Redirection après la réinitialisation du mot de passe</span>
        </template>
        <template #text>
          <v-select
            v-model="selectedWorkspace"
            item-text="label"
            item-value="code"
            :items="workspaces"
            label="Choisir le centre"
            outlined
            hide-details
            dense
            flat
            return-object
            solo
            style="max-width: 314px"
          />
        </template>
        <template #actions>
          <v-col>
            <v-btn width="314" class="mb-2" color="primary" :loading="loading" :disabled="!selectedWorkspace" @click="resetCustomerPassword">
              <span class="ml-2 d-none d-sm-inline-block">Réinitialiser</span>
            </v-btn>
            <v-btn width="314" class="" color="secondary" @click="closeSelectWorkspaceModal">
              <span class="ml-2 d-none d-sm-inline-block">Cancel</span>
            </v-btn>
          </v-col>
        </template>
      </Modal>
    </v-row>
  </div>
</template>

<script>
import { requests } from '@/mixins/index';

import { EventBus } from '../../mixins';
import Modal from '@/components/Modal/Modal';

const _ = require('lodash');

export default {
  components: { Modal },
  mixins: [requests],
  props: {
    field: Object,
    content: Object,
    value: [Boolean, String],
    contexts: Array,
    editable: Boolean,
    email: String,
    showResetPassword: {
      type: Boolean,
      default: true
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      loading: false,
      poolItems: [{ label: 'UCPA', value: 'speedboat' }, { label: 'Alpha', value: 'alpha' }, { label: 'LaBalaguere', value: 'labalaguere' }],
      create_digital_account: this.value,
      showResetPasswordButton: this.$props.showResetPassword && this.$props.content.digital_account,
      pool_name: this.$store.getters.getBrand === 'crm_labalaguere' ? 'labalaguere' : 'speedboat',
      selectedWorkspace: null,
      showSelectWorkspaceModal: false
    };
  },
  computed: {
    disableDigitalAccountOption () {
      // const disabledContexts = [
      //   // CGOS
      //   '1292',
      //   '1432',
      //   '5931',
      //   '339',
      //   '5760',
      //   '5756',
      //   '5757',
      //   '5759',
      //   '5758',
      //   '5849',
      //   '1067',
      //   '575',
      //   '1154',
      //   // CNAS
      //   '320',
      //   '5762',
      //   '5763',
      //   '5764',
      //   '5765',
      //   // CNOUS
      //   '5928',
      //   '2220',
      //   '3465',
      //   // C.G.O.S
      //   '5755',
      //   '5761'
      // ];

      // // If is a CNOS, CGOS or CNAS no digital account can be created
      // if (this.$props.contexts && _.intersection(disabledContexts, this.$props.contexts).length === this.$props.contexts.length) {
      //   this.disableDigitalAccountCreation();
      //   return true;
      // }

      // return false;

      const contextProject = {
        ucpa: 'crm',
        labalaguere: 'crm_labalaguere'
      };

      return this.$props.content.origin_source && !['ucpa', 'labalaguere'].includes(this.$props.content.origin_source) && contextProject[this.$props.content.origin_source] !== this.$store.state.brand;
    },
    workspaces() {
      const speedboatWorkspaces = (this.content.contexts || []).map(c => c.value).includes('speedboat') ? [
        {
          code: 'speedboat',
          label: 'SPEEDBOAT',
          siteUrl: '',
          project: 'speedboat'
        }
      ] : [];

      const alphaWorkspaces = this.$store.state.alphaWorkspaces.filter(workspace => {
        if ((this.content.contexts || []).some(context => ['alpha', 'pegase'].includes(context.value))) {
          return true;
        }

        if ((this.content.customer_workspaces || []).includes(workspace.code)) {
          return true;
        }

        return false;
      });

      const labalaguereWorkspaces = (this.content.contexts || []).map(c => c.value).includes('labalaguere') ? [
        {
          code: 'labalaguere',
          label: 'LABALAGUERE',
          siteUrl: '',
          project: 'labalaguere'
        }
      ] : [];

      if ((this.$store.state.user.roles || []).includes('admin')) {
        return [...speedboatWorkspaces, ...alphaWorkspaces, ...labalaguereWorkspaces];
      }

      let workspaces = [];

      if ((this.$store.state.user.roles || []).includes('speedboat_impersonate_mode')) {
        workspaces = [...workspaces, ...speedboatWorkspaces];
      }
      if ((this.$store.state.user.roles || []).includes('labalaguere_impersonate_mode')) {
        workspaces = [...workspaces, ...labalaguereWorkspaces];
      }

      if ((this.$store.state.user.roles || []).includes('alpha_impersonate_mode')) {

        if(this.$store.state.user.readWorkspaces.includes('*')) {
          workspaces = [...workspaces, ...alphaWorkspaces];
        } else {
          workspaces = [...workspaces, ...(alphaWorkspaces || []).filter(workspace => this.$store.state.user.readWorkspaces.includes(workspace.code))];
        }

        if(workspaces.length === 1) {
          this.selectedWorkspace = workspaces[0];
        }
      }

      return workspaces;
    }
  },
  watch: {
    create_digital_account (val) { // Updates v-model on the parent
      if (val) {
        this.$emit('input', this.pool_name);
      } else {
        this.$emit('input', val);
      }
    },
    pool_name (val) {
      this.$emit('input', val);
    }
  },
  mounted () {
    this.$emit('input', this.value);
  },
  methods: {
    disableDigitalAccountCreation () {
      this.create_digital_account = false;
    },
    async resetCustomerPassword () {
      this.loading = true;
      const resetPasswordResponse = await this.resetCustomerPasswordRequest(this.email, this.pool_name, 'EMAIL', this.selectedWorkspace);

      const message = resetPasswordResponse.success ? 'E-mail pour réinitialiser le mot de passe envoyé' : "Erreur lors de l'envoi d'un e-mail pour réinitialiser le mot de passe";

      const type = resetPasswordResponse.success ? 'success' : 'danger';

      const notification = {
        message: message,
        type: type,
        timeout: 16000
      };

      this.loading = false;
      this.closeSelectWorkspaceModal();
      EventBus.$emit('show-notifications', [notification]);
    },
    async handleResetCustomerPassword() {
      if ((this.content.contexts || []).some(context => ['alpha', 'pegase'].includes(context.value))) {
        this.showSelectWorkspaceModal = true;
        return;
      }
      await this.resetCustomerPassword();
    },
    closeSelectWorkspaceModal () {
      this.showSelectWorkspaceModal = false;
    }
  }
};
</script>
